







































































import { EmployeApi } from "../api/EmployeApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import { Employe } from "../models/Employe";
import Absence = Employe.Absence;
import AbsenceModal from "./AbsenceModal.vue";
import AbsencesTableHeader from "./AbsencesListPartials/AbsencesTableHeader.vue";

export default {
    name: "AbsenceList",
    components: { AbsencesTableHeader, AbsenceModal },
    props: {
        employeId: Number,
    },
    data() {
        return {
            absences: [],
            filters: { startDate: null, endDate: null },
            selectedAbsenceId: null,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.refreshAbsences();
    },
    methods: {
        refreshAbsences() {
            let self = this;
            if (self.employeId && self.employeId != 0) {
                self.EmployeApi.getAbsences(self.employeId).then(function (
                    res
                ) {
                    self.absences = res;
                });
            }
        },
        editAbsence(absence: Absence) {
            let self = this;
            self.selectedAbsenceId = null;
            setTimeout(function () {
                self.selectedAbsenceId = absence.id;
            });
        },
        deleteAbsence(absence: Absence) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cette absence ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removeAbsence(
                    self.employeId,
                    absence.id,
                    raison
                )
                    .then(function () {
                        self.refreshAbsences();
                    })
                    .catch(function () {
                        swal(
                            "L'absence n'a pas pu être supprimée.",
                            "",
                            "error"
                        );
                    });
            });
        },
    },
    computed: {
        displayedAbsences(): Absence[] {
            let self = this;
            return _.filter(self.absences, function (absence) {
                return (
                    !absence.is_conge &&
                    absence.date_debut <= self.filters.endDate &&
                    (!absence.date_fin ||
                        absence.date_fin >= self.filters.startDate)
                );
            });
        },
        totalAbsences(): number {
            return this.displayedAbsences.reduce(function (total, absence) {
                return total + (absence.duree || 0);
            }, 0);
        },
    },
};
